<template>
  <div v-if="tableData">
    <updated-list-component
      :table-headers="tableHeaders"
      :table-data="generateFavoritesData(tableData)"
      @open-message-modal="openMessageModal($event)"
      @remove-favorite="removeFavorite($event)"
      @remove-favorite-error="removeFavError($event)"
      @clicked="requestTour($event)"
    />
    <modal-send-message
      :show-modal="displayMessageModal"
      :selected-property="selectedProperty"
      @close-modal="closeMessageModal()"
      @submit-modal="sendMessage($event)"
    />
    <content-with-button-modal
      :modal-params="modalParams"
      :show-modal="displayFavError"
      @close-modal="displayFavError = false"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import ModalSendMessage from '../modals/ModalSendMessage.vue'
import UpdatedListComponent from '../../uiUtils/UpdatedListComponent.vue'
import ContentWithButtonModal from '../../modals/ContentWithButtonModal'
import { getPropertyKeyValue } from '../../../utils/propertyUtils'
import { sendMessageAboutHome } from '../../../services/messagesService'
import { activeRouteHomeIds } from '../../../services/routeService'
import colors from '../../../scss/_colors.scss'
import {
  requestPropertyTour,
  removeFromClientFavorite
} from '../../../services/propertiesService'

export default {
  components: {
    ModalSendMessage,
    UpdatedListComponent,
    ContentWithButtonModal
  },

  props: {
    options: {
      type: Object,
      required: false,
      default: function() {
        return {
          hideHeaders: false,
          hideActions: false
        }
      }
    },
    tableData: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      tableHeaders: [
        {
          text: 'Home Address',
          value: 'homeAddress',
          width: this.getWidth(),
          sortable: false
        },
        {
          text: 'Send Message',
          value: 'message',
          sortable: false,
          align: 'center',
          width: '10%'
        },
        {
          text: 'Favorite',
          value: 'favorite',
          sortable: false,
          align: 'center',
          width: '10%'
        },
        {
          text: 'Request Tour',
          value: 'requestTour',
          sortable: false,
          align: 'center',
          width: '20%'
        }
      ],
      modalParams: {
        title: `This property a part of an active route and hence can't be removed from your favorites list`,
        btnText: 'Ok'
      },
      displayFavError: false,
      displayPropertyModal: false,
      selectedProperty: null,
      displayMessageModal: false,
      selectedForRemoval: null
    }
  },

  computed: {
    ...mapState('home', ['windowWidth']),
    ...mapState('client', ['clientData', 'clientFavorites']),

    activeRouteHomeIds() {
      return activeRouteHomeIds(this.clientData)
    }
  },

  methods: {
    ...mapMutations('client', {
      setSavedFavWidgetRequestTracker: 'SET_SAVED_FAV_WIDGET_REQUEST_TRACKER'
    }),
    ...mapActions('client', ['updateClientPropertiesAction']),

    getWidth() {
      return this.$store.state.home.windowWidth < 960 ? '70%' : '60%'
    },

    generateFavoritesData(tableDataArray) {
      let responseData = []
      tableDataArray.map((item, index) => {
        let rowObject = {}
        rowObject[0] = {
          type: 'addressImg',
          icon: true,
          data: item
        }
        rowObject[1] = {
          type: 'icon',
          text: 'email',
          color: colors.pending,
          data: { type: 'message', value: item, action: 'open-message-modal' }
        }

        if (
          this.activeRouteHomeIds.includes(item.propertyId) ||
          item.requestTour === true
        ) {
          rowObject[2] = {}
          rowObject[3] = {
            text: 'TOUR REQUESTED',
            class: 'green--text',
            icon: 'check',
            iconClass: 'green--text',
            iconSize: '16'
          }
        } else {
          rowObject[2] = {
            type: 'icon',
            text: 'favorite',
            color: colors.modalIcon,
            data: {
              type: 'removeFav',
              value: item,
              action: 'remove-favorite'
            }
          }
          rowObject[3] = {
            type: 'clickable',
            color: this.$btnHwayzBlue,
            text: 'REQUEST TOUR',
            data: item
          }
        }

        responseData.push(rowObject)
      })
      return responseData
    },

    async removeFavorite(data) {
      const updatedClientProperties = await removeFromClientFavorite(
        this.clientData,
        this.clientFavorites,
        data
      )
      if (updatedClientProperties) {
        this.updateClientPropertiesAction(updatedClientProperties)
      }
    },

    async requestTour(data) {
      this.setSavedFavWidgetRequestTracker(true)
      const updatedClientProperties = await requestPropertyTour(
        this.clientData,
        this.clientFavorites,
        data
      )
      if (updatedClientProperties) {
        this.updateClientPropertiesAction(updatedClientProperties)
      }
    },

    openMessageModal(home) {
      this.displayMessageModal = true
      this.selectedProperty = this.clientFavorites.find(
        favorite => favorite._id === home.propertyId
      )
    },

    closeMessageModal() {
      this.displayMessageModal = false
      this.selectedProperty = null
    },

    async sendMessage(data) {
      await sendMessageAboutHome(data)
      this.closeMessageModal()
    },

    getHomeAddress(homeObject) {
      return getPropertyKeyValue(
        homeObject.propertyId,
        this.clientFavorites,
        'Address'
      )
    },

    removeFavError(data) {
      this.selectedForRemoval = data
      this.displayFavError = true
    }
  }
}
</script>
